export default "__VITE_ASSET__D$6Ynf3G__"